import { apiRequest } from "../util/apiUtils";

export const accessControlList = async (params) => {
  try {
    const res = await apiRequest("get", `/permission/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const accessControlEdit = async (params) => {
  try {
    const res = await apiRequest("put", `/permission/edit`, {
      body: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const accessControlAdd = async (params) => {
  try {
    const res = await apiRequest("post", `/permission/add`, {
      body: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const permissionDetails = async (params) => {
  try {
    const res = await apiRequest("get", `/permission/details`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
